import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PLoadingComponent } from './p-loading.component';
import { PSpinnerModule } from '../p-spinner/p-spinner.module';

@NgModule({
    declarations: [PLoadingComponent],
    imports: [CommonModule, PSpinnerModule],
    exports: [PLoadingComponent]
})
export class PLoadingModule {}
